import * as React from 'react';
import { SVGProps } from 'react';

const SvgHourFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" role="img" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm1.25-14a1.25 1.25 0 1 0-2.5 0v4.748l4.518 3.265a1.25 1.25 0 0 0 1.464-2.026L13.25 11.47V8Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgHourFilled;
